import { isString } from 'mathjs';
import Action from '../../classes/Action';
import AudioSource from '../../classes/AudioSource';
import AssetUtility from '../../classes/AssetUtility';
import store, { StoreActions } from '../../state/store';
import { AssetTypes } from '../../globals';
import AssetsManager from '../../classes/AssetsManager';

export default class ReplaceAudioAsset extends Action
{
	constructor(oldAssetId: string, newAssetId: string)
	{
		const oldAssetName = AssetUtility.getAssetName(oldAssetId);
		const newAssetName = AssetUtility.getAssetName(newAssetId);
		const actionName = "Replaced " + oldAssetName + " References With " + newAssetName;
		super([oldAssetId, newAssetId], [newAssetId, oldAssetId], actionName, [oldAssetId, newAssetId]);
	}

	do(oldAssetId: string, newAssetId: string) : void
	{
		for (const audioSource of AudioSource.audioSourceBank)
		{
			if (audioSource.userData.audio.clip === oldAssetId)
			{
				audioSource.setAudioClip(newAssetId);
			}
		}

		store.dispatch(StoreActions.ui.replaceAsset({ oldId: oldAssetId, newId: newAssetId }));
	}

	verify(oldAssetId: string, newAssetId: string) : boolean
	{
		return 	oldAssetId !== newAssetId && 
				isString(oldAssetId) && isString(newAssetId) &&
				AssetsManager.getAssetInfo(oldAssetId)?.type === AssetTypes.Audio && 
				AssetsManager.getAssetInfo(newAssetId)?.type === AssetTypes.Audio;
	}
}
